// Umgebung aus .env (siehe .env.example). Vite ersetzt import.meta.env zur
// Bauzeit; ohne VITE_API_URL laeuft nichts, deshalb hier laut scheitern.
export const APIUrl = import.meta.env.VITE_API_URL;
export const googleMapsKey = import.meta.env.VITE_GOOGLE_MAPS_KEY ?? "";

if (!APIUrl) {
    throw new Error("VITE_API_URL fehlt - .env aus .env.example anlegen");
}
